import { ValidationDefinitionDTO } from "../DTO/validationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateValidationDefinitionRequest extends BasicRequest{
   
    public validationDefinition! : ValidationDefinitionDTO;
    
    constructor(){
        super()
    }
}